/* Values are injected by web/webpack.config.js from the selected .env file. */
export default __APP_CONFIG__;
